module.exports = [
	{
	  id: 'total',
	  display: 'Total'
	},
	{
	  id: 'commitment',
	  display: 'Governance'
	}, 
	{
	  id: 'freedom',
	  display: 'Freedom of Expression'
	}, 
	{
	  id: 'privacy',
	  display: 'Privacy'
	}
];
